export default function CallToAction() {
  return (
    <div className="justify-center grid">
      <h2 className="text-xl md:text-4xl text-gray-900 text-center pb-[20px]">
        DISCOVER LIMITLESS <br /> <b>OPPORTUNITIES:</b>
      </h2>
      <p className="text-xl md:text-4xl font-normal text-gray-800 text-center">
        Start Your Journey with <br />
        <span className="text-black md:text-[#282365] font-semibold">
          Sir Padampat Singhania University
        </span>
      </p>
      <div className="bg-[#282365e0] md:bg-[#282365] text-white text-sm md:text-lg inline-block w-full text-center font-normal px-4 py-2 rounded-md mt-[5.5rem] md:mt-3 md:hidden">
        Join Us for the <span className="font-bold">2025-26</span> Academic Year
        – Applications Open
      </div>
    </div>
  );
}
